export interface DocumentHeader {
    enabled: boolean
    logo: string | null
    title: string
    subtitle: string
    addressLine: string
    contactLine: string
    /** Quando true, logo/título/subtítulo/endereço/contato são resolvidos a partir dos dados
     * cadastrais da empresa em vez dos campos digitados manualmente aqui. */
    useCompanyData: boolean
}

export interface DocumentFooter {
    enabled: boolean
    text: string
}

export interface DocumentSignature {
    /** Se true, ao concluir o preenchimento público o botão final vira "Assinar" e a assinatura
     * já é iniciada automaticamente (ver form-v2-form-fill.svelte). */
    requested: boolean
    /** 1 = link de assinatura (simples), 2 = e-mail (avançada) — mesmos valores de MODE_LINK/MODE_EMAIL
     * usados em form-v2-sign-popover.svelte. */
    mode: number
}

export interface DocumentHeaderFooter {
    header: DocumentHeader
    footer: DocumentFooter
    signature: DocumentSignature
}

export function createDefaultHeaderFooter(): DocumentHeaderFooter {
    return {
        header: { enabled: false, logo: null, title: '', subtitle: '', addressLine: '', contactLine: '', useCompanyData: true },
        footer: { enabled: false, text: '' },
        signature: { requested: false, mode: 1 },
    }
}
